<kendo-dialog class="terms-of-service-dialog" *ngIf="(isMember$ | async) && !agreed">
  <kendo-dialog-titlebar> Terms Of Service </kendo-dialog-titlebar>
  <kendo-pdfviewer
    [url]="pdfUrl"
    (load)="onLoad($event)"
    (pageChange)="onPageChange($event)"
    style="height: 600px"
    [tools]="['pager', 'zoomInOut', 'zoom', 'download', 'print']"
  >
  </kendo-pdfviewer>

  <kendo-dialog-actions layout="end">
    <button kendoButton [disabled]="!allPagesRead" (click)="onAgree(true)">
      I Agree, don't remind me again
    </button>
    <button
      kendoButton
      [disabled]="!allPagesRead"
      (click)="onAgree(false)"
      themeColor="success"
    >
      I Agree
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
